import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col, Button, InputGroup, Input } from 'reactstrap';
import {CurrentTheme, CurrentLang, StringUtils } from "common";

const AUTO_COMPLETE_OFF = 'off';

class MagstimSimpleSearchControl extends React.Component {

    constructor(props) {
        super(props);

        this._searchInput = React.createRef();
    }

    getSearchPlaceholder = () => {
        var retVal = [];

        if (this.props.table !== null && this.props.table.current !== undefined && this.props.table.current !== null) {

            const columns = this.props.table.current.getColumns();
            if (columns !== undefined) {
                columns.forEach(item => {
                    if (item.isSearchable === true) {
                        retVal.push(item.title);
                    }
                })
            }
        }

        if (retVal.length > 0) {
            return StringUtils.format(CurrentLang().search_placeholder, [retVal.join(', ').toLowerCase()]);
        }

        return StringUtils.format(CurrentLang().search_placeholder, "");
    }

    onSearchChange = (text) => {
        if (this.props.table.current !== undefined && this.props.table.current !== null) {
            this.props.table.current.search(text);
        }
    }

    onClearSearch = () => {
        if (this.props.table.current !== undefined && this.props.table.current !== null) {
            // Clear the table search 
            this._searchInput.current.value = "";
            this.props.table.current.search();
        }
    }

    render() {

        var searchPlaceholder = " " + this.getSearchPlaceholder();

        return (
            <Wrapper>
                <Row className="ui-bg">
                    <Col  xs="11" className="mb-2 mt-3">
                        <InputGroup className="mr-auto ml-auto" size={CurrentTheme().ControlSize}>
                            <Input type="text" autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus}
                                name="search"
                                className="fontAwesome-placeholder"
                                placeholder={searchPlaceholder}
                                innerRef={this._searchInput}
                                onChange={(e) => this.onSearchChange(`${e.target.value}`)}
                            />

                        </InputGroup>
                    </Col>
                    <Col xs="1" className="mb-2 mt-3 pr-2">
                        <Button color="secondary" className="float-right top-bar-btn" onClick={this.onClearSearch} size={CurrentTheme().ControlSize} >
                            <i className="fas fa-list" ></i>
                        </Button>
                    </Col>
                </Row>
            </Wrapper>
        );
    }
}

MagstimSimpleSearchControl.propTypes = {
    table: PropTypes.object,
};

MagstimSimpleSearchControl.defaultProps = {
    table: undefined,
};

const Wrapper = styled.div`

.fontAwesome-placeholder {
    font-family: 'Montserrat', FontAwesome, sans-serif;
  }

`

export default MagstimSimpleSearchControl;